export const themes = {
  light: {
    background: "#F6F6F7",
    scrollbarTrack: "#FFFF",
    scrollbarThumb: "#E8E8E8",
    backgroundSecondary: "#FCFCFC",
    addColumnBtn: "#161616",
    addColumnIcon: "#FFF",
    needHelp: "#F6F6F7",
    sidebar: "#fff",
    icon: "#1F1F1F",
    logo: "#1F1F1F",
    hoverColor: "#9dc888",
    buttonText: "#161616",
    modalButton: "#161616",
    iconButton: "#fff",
    text: "#161616",
    primary: "#BEDBB0",
    secondaryText: "#16161680",
    sidebarText: "#16161680",
    accent: "#BEDBB0",
    boardOverlay: "rgba(190, 219, 176, 0.45)",
    labelText: "#161616",
    labelHighPriority: "#BEDBB0",
    labelMediumPriroity: "#E09CB5",
    labelLowPriority: "#8FA1D0",
    labelWithoutPriority: "#807c7c4d",
  },
  dark: {
    background: "#1F1F1F",
    scrollbarTrack: "rgba(255, 255, 255, 0.1)",
    scrollbarThumb: "#161616",
    backgroundSecondary: "#161616",
    needHelp: "#1F1F1F",
    addColumnBtn: "#FFFFFF",
    addColumnIcon: "#161616",
    sidebar: "#121212",
    icon: "#1F1F1F",
    logo: "#ffffff",
    modalButton: "#161616",
    hoverColor: "#9dc888",
    iconButton: "#fff",
    buttonText: "#161616",
    text: "#ffffff",
    primary: "#BEDBB0",
    secondaryText: "#FFFFFF80",
    sidebarText: "#FFFFFF80",
    accent: "#BEDBB0",
    boardOverlay: "rgba(190, 219, 176, 0.45)",
    labelText: "#161616",
    labelHighPriority: "#BEDBB0",
    labelMediumPriroity: "#E09CB5",
    labelLowPriority: "#8FA1D0",
    labelWithoutPriority: "#807c7c4d",
  },
  violet: {
    background: "#ECEDFD",
    scrollbarTrack: "#FFFFFF",
    scrollbarThumb: "#B8BCFD",
    backgroundSecondary: "#FCFCFC",
    addColumnBtn: "#5255BC",
    addColumnIcon: "#FFF",
    needHelp: "#7B7EDE",
    sidebar: "#5255BC",
    icon: "#B8BCFD",
    logo: "#fff",
    iconButton: "#161616",
    modalButton: "#FFFFFF",
    buttonText: "#FCFCFC",
    hoverColor: "#7B7EDE",
    text: "#161616",
    primary: "#5255BC",
    secondaryText: "#16161680",
    sidebarText: "rgba(255, 255, 255, 0.5)",
    accent: "#B8BCFD",
    boardOverlay: "rgba(70, 73, 131, 0.5)",
    labelText: "#FFFFFF",
    labelHighPriority: "#BEDBB0",
    labelMediumPriroity: "#E09CB5",
    labelLowPriority: "#8FA1D0",
    labelWithoutPriority: "#807c7c4d",
  },
};
